import React, { lazy, Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { convertToCamelCase } from "../utils/helpers";
import ErrorBoundary from "../components/ErrorBoundary/ErrorBoundary";
import Spinner from "../components/Spinner/Spinner";
import { fetchPagesSections } from "../actions/pages-actions";
import { pagesActions } from "../store/pages-slice";
import { useParams } from "react-router-dom";

const loadComponent = (name) => {
  try {
    return lazy(() => import(`../components/${name}/${name}.js`));
  } catch (error) {
    console.error(`Failed to load component ${name}`, error);
    return null;
  }
};

const Page = ({ slug }) => {
  const loading = useSelector((state) => state.pages.loadingData);
  const { postSlug } = useParams();
  const dispatch = useDispatch();
  const postData = useSelector((state) => state.pages.postData?.[postSlug]);

  let pageSlug = slug;
  let apiSlug = "pages";
  if ("home" === slug) {
    pageSlug = "home";
  } else if ("service" === pageSlug) {
    apiSlug = "service";
    pageSlug = postSlug;
  } else if ("posts" === pageSlug) {
    apiSlug = "posts";
    pageSlug = postSlug;
  } else if ("project" === pageSlug) {
    apiSlug = "project";
    pageSlug = postSlug;
  } else if ("job" === pageSlug) {
    apiSlug = "job";
    pageSlug = postSlug;
  }

  const sections = useSelector(
    (state) => state.pages.sections[apiSlug + pageSlug]
  );

  useEffect(() => {
    if (!sections) {
      dispatch(pagesActions.setLoadingData(true));
      dispatch(fetchPagesSections(apiSlug, pageSlug));
    }
  }, [dispatch, apiSlug, sections]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div>
      <Suspense fallback={<Spinner />}>
        {sections &&
          sections.map((section, index) => {
            const componentName = convertToCamelCase(section.acf_fc_layout);
            const Component = loadComponent(componentName);

            return (
              <ErrorBoundary key={index}>
                {Component ? (
                  <Component key={index} data={section} />
                ) : (
                  <div>Component not found: {componentName}</div>
                )}
              </ErrorBoundary>
            );
          })}
      </Suspense>
    </div>
  );
};

export default Page;
